var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVolvo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.519043 0.686569V2.80995H4.0019L10.8177 15.5922H19.205L26.0208 2.78873L29.5031 2.76678L29.5107 0.686569H19.0913V2.77404H21.8661L17.0531 11.8612L11.848 2.80573L15.6445 2.78873L15.6378 0.686569H0.519043Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7378 0.686569V2.80995H71.2196L78.0356 15.5922H86.4232L93.239 2.78873L96.7217 2.76678L96.728 0.686569H86.3105V2.77404H89.0841L84.2713 11.8612L79.0655 2.80573L82.8633 2.78873L82.8561 0.686569H67.7378Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6002 0.68657V2.80995H54.0824L54.0882 13.2456H50.417V15.5716L54.0907 15.5924H71.4784V8.65401H69.2134C69.0893 12.3276 65.9025 13.2505 64.5602 13.2505C63.3303 13.2505 60.9471 13.2457 60.9471 13.2457V2.80573L64.3771 2.78858L64.3724 0.686424L50.6002 0.68657Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.723 13.6834C36.6362 13.6834 34.9455 11.1838 34.9455 8.09885C34.9455 5.01314 36.6362 2.51165 38.723 2.51165C40.8091 2.51165 42.5005 5.01314 42.5005 8.09885C42.5005 11.1838 40.8091 13.6834 38.723 13.6834ZM38.8765 0.258316C32.9571 0.258316 28.1587 3.78304 28.1587 8.12923C28.1587 12.4757 32.957 16 38.8765 16C44.7954 16 49.5946 12.4757 49.5946 8.12923C49.5946 3.78304 44.7954 0.258316 38.8765 0.258316Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.942 13.6437C103.856 13.6437 102.165 11.1027 102.165 7.96671C102.165 4.83186 103.856 2.29026 105.942 2.29026C108.028 2.29026 109.718 4.83186 109.718 7.96671C109.719 11.1026 108.028 13.6437 105.942 13.6437ZM106.096 0C100.175 0 95.3784 3.58214 95.3784 7.99927C95.3784 12.4163 100.175 15.9977 106.096 15.9977C112.015 15.9977 116.813 12.4163 116.813 7.99927C116.813 3.58214 112.015 0 106.096 0Z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.519043 0.686569V2.80995H4.0019L10.8177 15.5922H19.205L26.0208 2.78873L29.5031 2.76678L29.5107 0.686569H19.0913V2.77404H21.8661L17.0531 11.8612L11.848 2.80573L15.6445 2.78873L15.6378 0.686569H0.519043Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7378 0.686569V2.80995H71.2196L78.0356 15.5922H86.4232L93.239 2.78873L96.7217 2.76678L96.728 0.686569H86.3105V2.77404H89.0841L84.2713 11.8612L79.0655 2.80573L82.8633 2.78873L82.8561 0.686569H67.7378Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6002 0.68657V2.80995H54.0824L54.0882 13.2456H50.417V15.5716L54.0907 15.5924H71.4784V8.65401H69.2134C69.0893 12.3276 65.9025 13.2505 64.5602 13.2505C63.3303 13.2505 60.9471 13.2457 60.9471 13.2457V2.80573L64.3771 2.78858L64.3724 0.686424L50.6002 0.68657Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.723 13.6834C36.6362 13.6834 34.9455 11.1838 34.9455 8.09885C34.9455 5.01314 36.6362 2.51165 38.723 2.51165C40.8091 2.51165 42.5005 5.01314 42.5005 8.09885C42.5005 11.1838 40.8091 13.6834 38.723 13.6834ZM38.8765 0.258316C32.9571 0.258316 28.1587 3.78304 28.1587 8.12923C28.1587 12.4757 32.957 16 38.8765 16C44.7954 16 49.5946 12.4757 49.5946 8.12923C49.5946 3.78304 44.7954 0.258316 38.8765 0.258316Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.942 13.6437C103.856 13.6437 102.165 11.1027 102.165 7.96671C102.165 4.83186 103.856 2.29026 105.942 2.29026C108.028 2.29026 109.718 4.83186 109.718 7.96671C109.719 11.1026 108.028 13.6437 105.942 13.6437ZM106.096 0C100.175 0 95.3784 3.58214 95.3784 7.99927C95.3784 12.4163 100.175 15.9977 106.096 15.9977C112.015 15.9977 116.813 12.4163 116.813 7.99927C116.813 3.58214 112.015 0 106.096 0Z"
  })));
});
export default SvgVolvo;
export const raw = __webpack_public_path__ + "static/media/volvo.6b9737cea1472504c86c19e1e68f57d2.svg";